import { Pipe, PipeTransform } from '@angular/core';

import { GetBooleanResultPipe } from './get-boolean-result.pipe';

@Pipe({ name: 'arrayFilter' })
export class ArrayFilterPipe implements PipeTransform {

  /* transform(): Pipe que devuelve los objetos de una matriz que cumplan con una condición específica
    value: Matriz a evaluar
    field: Propiedad a evaluar por objeto
    condition: Valor a comparar según el operador
    operator: Operación a utilziar para la comparación
    cast: Obligar valores a un tipo específico para que la comparación de tipos coincida
  */
  transform<T extends Record<string, object | any[]>>(value: T, field: string, condition: any, operator: string, cast?: string): Partial<T>;
  transform<T extends (object | any[])[]>(value: T, field: string, condition: any, operator: string, cast?: string): T;
  transform(value: Record<string, object | any[]> | (object | any[])[], field: string, condition: any, operator: string, cast?: string) {
    // ↓ Devuele los objetos que cumplen con una condición específica
    if (Array.isArray(value)) {
      return value.filter((elm: (object | any[])[]) => {
        // elm[field]: valor de la propiedad del objeto
        return new GetBooleanResultPipe().transform(elm[field], condition, operator, cast);
        // ↑ Devuelve el resultado de la operación seleccionada
      });
    } else {
      return Object.entries(value).reduce((response, [key, elm]) => {
        if (new GetBooleanResultPipe().transform(elm[field], condition, operator, cast)) {
          response[key] = elm;
        }
        return response;
      }, {});
    }

  }

}
